import { registerBeginnerMathBlocks as defineMathBlocks } from './math-blocks.js';

let registered = false;

export function registerBeginnerMathBlocks(): void {
  if (registered) {
    return;
  }
  defineMathBlocks();
  registered = true;
}
